import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as strings from './strings.js';
var hasBuffer = typeof Buffer !== 'undefined';
var hasTextDecoder = typeof TextDecoder !== 'undefined';
var textDecoder;
export var VSBuffer = /*#__PURE__*/function () {
  function VSBuffer(buffer) {
    _classCallCheck(this, VSBuffer);

    this.buffer = buffer;
    this.byteLength = this.buffer.byteLength;
  }

  _createClass(VSBuffer, [{
    key: "toString",
    value: function toString() {
      if (hasBuffer) {
        return this.buffer.toString();
      } else if (hasTextDecoder) {
        if (!textDecoder) {
          textDecoder = new TextDecoder();
        }

        return textDecoder.decode(this.buffer);
      } else {
        return strings.decodeUTF8(this.buffer);
      }
    }
  }]);

  return VSBuffer;
}();
export function readUInt16LE(source, offset) {
  return source[offset + 0] << 0 >>> 0 | source[offset + 1] << 8 >>> 0;
}
export function writeUInt16LE(destination, value, offset) {
  destination[offset + 0] = value & 255;
  value = value >>> 8;
  destination[offset + 1] = value & 255;
}
export function readUInt32BE(source, offset) {
  return source[offset] * Math.pow(2, 24) + source[offset + 1] * Math.pow(2, 16) + source[offset + 2] * Math.pow(2, 8) + source[offset + 3];
}
export function writeUInt32BE(destination, value, offset) {
  destination[offset + 3] = value;
  value = value >>> 8;
  destination[offset + 2] = value;
  value = value >>> 8;
  destination[offset + 1] = value;
  value = value >>> 8;
  destination[offset] = value;
}
export function readUInt8(source, offset) {
  return source[offset];
}
export function writeUInt8(destination, value, offset) {
  destination[offset] = value;
}